export const SET_BETSLIPS = '[APP] SET BETSLIPS';
export const ON_BETSLIP_SELECTED = '[APP] ON BETSLIP SELECTED';
export const SET_SINGLE_BETSLIP = '[APP] SET SINGLE BETSLIP';
export const SET_MYBET_FILTER_PARAMS = '[APP] SET MYBET FILTER PARAMS';
export const REMOVE_MYBET_FILTERS_PARAMS = '[APP] REMOVE MY BET FILTER PARAMS';